export const validateCollaborationForm = (data) => {
  const errors = {};
  if (!data.title?.trim()) {
    errors.title = "Theme name is required.";
  }
  if (!data.licensorLabel?.trim()) {
    errors.licensorLabel = "Licensor label is required.";
  }
  if (!data.startDate?.trim()) {
    errors.startDate = "Theme start date is required.";
  }
  if (!data.endDate?.trim()) {
    errors.endDate = "Theme end date is required.";
  }
  if (!data.primaryColor) {
    errors.primaryColor = "Primary color is required.";
  }
  if (!data.secondaryColor) {
    errors.secondaryColor = "Secondary color is required.";
  }
  if (!data.tertiaryColor) {
    errors.tertiaryColor = "Tertiary color is required.";
  }
  if (!data.galleries) {
    errors.galleries = "Galleries is required.";
  }
  if (!data.banners) {
    errors.banners = "Banners is required.";
  }
  if (!data.videos) {
    errors.videos = "Videos is required.";
  }
  if (!data.menus) {
    errors.menus = "Menus is required.";
  }
  if (!data.lineUps) {
    errors.lineUps = "Line Ups is required.";
  }
  if (!data.logo) {
    errors.logo = "Logo is required.";
  }
  if (!data.merchandises) {
    errors.merchandises = "Merchandises is required.";
  }
  return errors;
};
